import { Avatar, Box, Button, Typography, useTheme } from "@mui/material";
import OTP from "app/components/Auth/OTP";
import logo from "assets/icons/referee-main.svg";
import { Form, Formik } from "formik";
import {
  selectForgotPasswordEmail,
  setForgotPasswordOtp,
} from "lib/features/auth/authSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authServices, { VerifyOtpDto } from "services/auth-service";
import { authStyles } from "styles/common/auth.styles";
import * as Yup from "yup";

const otpValidation = Yup.object({
  otp: Yup.string().required("Otp is required"),
});

const VerifyOTP = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const forgotPasswordEmail = useSelector(selectForgotPasswordEmail);

  const [loader, setLoader] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const initialValues: VerifyOtpDto = {
    email: "",
    otp: "",
  };

  const onSubmit = async (values: VerifyOtpDto) => {
    if (!forgotPasswordEmail) return;
    values.email = forgotPasswordEmail;

    try {
      setLoader(true);
      const result = await authServices.verifyOtp(values);
      if (result.status === 201) {
        dispatch(setForgotPasswordOtp(values.otp));
        navigate("/reset-password");
      }
    } catch (error: any) {
      setError(error?.response?.data?.message);
      setTimeout(() => {
        setError(undefined);
      }, 3000);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!forgotPasswordEmail) {
      return navigate(-1);
    }
  }, []);

  return (
    <Box width="100%" position="relative">
      <Box sx={authStyles.authContainer(theme)}>
        <Box sx={authStyles.avatarContainer}>
          <Avatar sx={authStyles.avatar}>
            <img src={logo} alt="logo" style={authStyles.avatarImage} />
          </Avatar>
        </Box>

        <Box sx={authStyles.textContainer}>
          <Typography variant="h6" textAlign={"center"}>
            Verify Your Account
          </Typography>
          <Typography variant="body2" textAlign={"center"}>
            Please input the verification code sent to your email{" "}
            <strong>{forgotPasswordEmail}</strong>.
          </Typography>
        </Box>

        <Formik
          initialValues={initialValues}
          validationSchema={otpValidation}
          onSubmit={(values) => onSubmit(values)}
        >
          {({ values, errors, touched, setFieldValue }) => (
            <Form>
              <OTP
                otp={values.otp}
                setOtp={(value: string) => setFieldValue("otp", value)}
              />
              {errors.otp && touched.otp && (
                <Typography color="red" fontSize="12px" mt={2}>
                  {errors.otp}
                </Typography>
              )}

              {error && (
                <Typography sx={authStyles.errorText}>{error}</Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                sx={authStyles.actionBtn}
                disabled={loader}
              >
                Verify Otp
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default VerifyOTP;
